import { LayoutMarginToken, TMargin } from './margin'
import { LayoutPaddingToken, TPadding } from './padding'

export default {
  margin: LayoutMarginToken,
  padding: LayoutPaddingToken,
}

export type TLayout = TMargin | TPadding
